import http from "../utils/axios";
// 登陆
export const login = data => {
  return http({
    url: "/api/user/sysLogin", // 接口
    method: "post",
    data: data
  });
};
// 退出
export const logout = data => {
  return http({
    url: "/api/user/logout", // 接口
    method: "post",
    data: data
  });
};
